import React from 'react'
import { plan } from '../../utility/plan'
import { Fade } from 'react-awesome-reveal'

function Plans() {

    const handleSubmit = (e) => {
        e.preventDefault()
    }

    return (
        <section className="section-plans padding-tb-100 bg-market">
            <div className="container">
                <div className="row">
                    <div className="col-12">
                        <div className="banner justify-content-center">
                            <h2>Pricing Plans</h2>
                        </div>
                    </div>
                    <Fade triggerOnce duration={1000} direction='up' className="col-lg-4 col-sm-12 main-plan">
                        {
                            plan.map((data, index) => (

                                <div key={index} className="zx-plans">
                                    <div className="basic">
                                        <p>{data.title}</p>
                                    </div>
                                    <div className="zx-body">
                                        <div className="zx-month">
                                            <h4><span className="text-color">$</span> <code className="text-color">{data.price}</code> / per month
                                            </h4>
                                        </div>
                                        <div className="zx-seo">
                                            <p><code className="text-color">*</code>{data.storage}</p>
                                            <p><code className="text-color">*</code>{data.bandwidth}</p>
                                            <p><code className="text-color">*</code>{data.database}</p>
                                            <p><code className="text-color">*</code>{data.email_account}</p>
                                            <p><code className="text-color">*</code>{data.technical_support}</p>
                                        </div>
                                    </div>
                                    <div className="close-plans">
                                        <a onClick={handleSubmit} href="/">Choose Your Plan</a>
                                        <i className="fa-solid fa-arrow-right-long"></i>
                                    </div>
                                </div>

                            ))
                        }

                    </Fade>
                </div>
            </div>
        </section>
    )
}

export default Plans
